define([
    "dojo/_base/declare",
    "dojo/dom",
    "dojo/dom-class",
    "dojo/dom-geometry",
    "dojo/dom-style",
    "dijit/layout/_LayoutWidget",
    "MW/layout/LayoutUtils",
    "MW/layout/TitleBar"
], function (declare, dom, domClass, domGeometry, domStyle, _LayoutWidget, LayoutUtils, TitleBar) {

    /**
     * Defines a wrapper that includes a child widget plus a title bar.
     */
    return declare([_LayoutWidget], {

        showTitleBar: true,

        postCreate: function () {
            this.inherited(arguments);
            domClass.add(this.domNode, "titledPane");

            if (this.showTitleBar) {
                if (!this.titleBar) {
                    this.titleBar = new TitleBar({
                        id: this.contentWidget.id + "TitledPaneTitleBar",
                        properties: this.contentProperties,
                        title: this.title
                    });
                    this._createdTitleBar = true;
                }
                domStyle.set(this.titleBar.domNode, "position", "absolute");
                this.addChild(this.titleBar);
            }
            domStyle.set(this.contentWidget.domNode, "position", "absolute");
            this.addChild(this.contentWidget);
        },

        /**
         * Destroy the TitledPane and its TitleBar but not the wrapped content widget
         */
        destroy: function () {
            this.removeChild(this.contentWidget);
            if (this.showTitleBar && !this._createdTitleBar) {
                this.removeChild(this.titleBar);
            }
            this.inherited(arguments);
        },

        layout: function() {
            if (!this._started || !this.domNode) {
                return;
            }
            // Cache the computed style
            if (!this.computedStyle) {
                this.computedStyle = domStyle.getComputedStyle(this.domNode);
            }
            var contentBox = domGeometry.getContentBox(this.domNode, this.computedStyle);
            if (!contentBox || contentBox.h === 0) {
                return;
            }

            if (this.showTitleBar) {
                var titleBox = {l: 0, t: 0, w: contentBox.w, h: TitleBar.getPreferredHeight()};
                domGeometry.setMarginBox(this.titleBar.domNode, titleBox);
                contentBox.t += titleBox.h;
                contentBox.h -= titleBox.h;
            }

            LayoutUtils.setSize(this.contentWidget, contentBox);
        }
    });
});
